__turbopack_context__.v({
  "horizontal": "nav-rail-module__s9iIVq__horizontal",
  "navRail": "nav-rail-module__s9iIVq__navRail",
  "pill": "nav-rail-module__s9iIVq__pill",
});
